import { createSlice } from '@reduxjs/toolkit';

import { ICamera } from 'src/types/camera';
import { IRole } from 'src/types/role';
import { deleteOrderRole, getOrderRoles } from './actions';

interface ICustomerMembersState {
  camerasWithoutCustomer: ICamera[];
  roles: IRole[];
  roleDetail: IRole | null;
}

const initialState: ICustomerMembersState = {
  camerasWithoutCustomer: [],
  roles: [],
  roleDetail: null,
};

const orderRoles = createSlice({
  name: 'orderRoles',
  initialState,
  reducers: {
    setRole: (state, action) => {
      state.roleDetail = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getOrderRoles.fulfilled, (state, action) => {
        state.roles = action.payload;
      })
      .addCase(deleteOrderRole.fulfilled, (state, action) => {
        state.roles = state.roles.filter((role) => role.id !== action.payload);
      });
  },
});

const { reducer, actions } = orderRoles;
export const { setRole } = actions;
export default reducer;
